import React from 'react';
import { Typography, Box, withStyles, WithStyles, CardMedia } from '@material-ui/core';
import { mensajeMovilStyles } from '../../styles';
import { IMensaje, IGuia } from '../../interface';
import { IContenidoMensaje } from '../../interface/IContenidoMensaje';
import { fechaOrganizada,nombreMensaje } from '../../functions/index';
import { ImagenMensaje } from './ImagenMensaje';
import { Alerta} from '../atoms';

interface MensajeMovilProp extends WithStyles<typeof mensajeMovilStyles> {
    guia: IGuia
    mensaje:IMensaje
    children?: React.ReactNode;
    className?: string;
    open: boolean;
    handClose: () => void;
}

export const ContenidoMensajeMovil = ({nombre,bgColor,borderRadius,fontColor,mensaje,mobile,hora,fecha,type}:IContenidoMensaje, props: MensajeMovilProp) => {
    const [abierto, setOpen] = React.useState(false);

    const handleOpen = () => {
        setOpen(true);
    };
    
    const handleClose = () => {
        setOpen(false);
    };

    const borderRadio = nombre.includes('Destinatario') ?  '12px 12px 0px 12px' : '12px 12px 12px 0px' ;
    console.log(borderRadio);
    


    return(
        <Box height="50%" width="100%" >        
        {
            type==="IMAGE" ?
            <Box border="1">
            <Box borderRadius={borderRadius} p='0.9%' display="flex"
            justifyContent="flex-start"
            alignItems="flex-start">
                
                <Box  style={{backgroundColor:bgColor,width: 260, height:275}} borderRadius={borderRadius} onClick={() => handleOpen()}>
                    <Box paddingLeft={'5px'} paddingRight={'5px'} paddingTop={'5px'}>
                       <Box fontSize={10} marginBottom='2%'>{nombre}</Box>
                       <Box display="flex" justifyContent="center" alignItems="center">
                       {
                         <CardMedia
                          component="img"
                          style={{width: 232, height:232,  borderRadius:'5px', border: '2px #3A3B3D'}}
                          image={mensaje}
                          title="Live from space album cover"
                        />
                        }
                       </Box>
                       <Box paddingRight={'5px'} fontSize={12} marginTop='2%' display="flex"
                    justifyContent="flex-end"
                    alignItems="flex-end">{fecha.slice(-8)}
                    </Box>
                    
                    </Box>
                    

                   
                </Box>

                <Box>
                <div><ImagenMensaje mensaje={mensaje} mobile={mobile} open={abierto} handleClose={handleClose} /></div>
                </Box>
            
            </Box>
        

            
            </Box>
            :
                   <Box paddingRight={0.5} paddingLeft={1} bgcolor={bgColor} borderRadius={borderRadio}  color={fontColor} fontSize={18}>
                     <Box fontSize={12}>{nombre}</Box>
                     <Box  display="flex" flexDirection="row">
                         <Box >{ mensaje }</Box>        
                     </Box>
                     <Box display="flex" flexDirection="row-reverse">
                         <Box  color={fontColor} marginRight="0.7%"  fontSize={11} >{fecha.slice(-8)}</Box>
                     </Box>  
                   </Box>    
        }

    </Box>

    );
}


    

export const MensajeMovilComponent = (props:MensajeMovilProp) => {
    const mensaje = props.mensaje;

    let component:JSX.Element;
    if (mensaje.Remitente==='Cliente') {
        component=<MensajeComponenteCliente {...props}/>
        
    } else {
        component=<MensajeComponenteEmpleado {...props}/>
    }
    return component
}

export const MensajeComponenteEmpleado = (props:MensajeMovilProp) :JSX.Element => {
    const classes = props.classes;
    const mensaje = props.mensaje;

    let ultimaFecha:string = '';
    if (mensaje.Timestamp) {
        const ultimoMensaje = fechaOrganizada(mensaje.Timestamp as string);
         ultimaFecha = `${ultimoMensaje.diaNombre} ${ultimoMensaje.hora}`;
    }
    let styles:IContenidoMensaje;
    let component:JSX.Element;
    styles={
        bgColor:'#DDDDDD',
        fecha:ultimaFecha,
        borderRadius:'5px 5px 5px 0px',
        fontColor:'#3A3B3D',
        mensaje: mensaje.Mensaje,
        nombre: mensaje.Nombre ? nombreMensaje(mensaje.Nombre,mensaje.Remitente) : '',
        mobile: mensaje.Mobile ? mensaje.Mobile : false,
        type: mensaje.Type
    }
    switch (mensaje.Type) {
        case 'ALERTA_SOPORTE':
            return component = <Box marginRight={1}  marginLeft={1}>
                                   <Alerta guia={props.guia} tipo={3} mensaje_={props.mensaje} mensaje={mensaje.Mensaje}/>
                                </Box> ;
        case 'FINALIZADO':
            return component = <Box marginRight={1}  marginLeft={1}>
                                   <Alerta mensaje_={props.mensaje}  tipo={2}/>
                                </Box> ;
        case 'CAUSAL_DETAIL':
            return component = <Box marginRight={1}  marginLeft={1}>
                                   <Alerta guia={props.guia} mensaje_={props.mensaje} tipo={5}/>
                                </Box> ;
        case 'IN_ASESOR':
            return component = <Box marginRight={1}  marginLeft={1}>
                                   <Alerta guia={props.guia} mensaje_={props.mensaje} tipo={6}/>
                                </Box> ;
        case 'OUT_ASESOR':
            return component = <Box marginRight={1}  marginLeft={1}>
                                    <Alerta guia={props.guia} mensaje_={props.mensaje} tipo={6}/>
                                </Box> ;
        case 'IN_REPARTIDOR':
            return component = <Box marginRight={1}  marginLeft={1}>
                                    <Alerta guia={props.guia} mensaje_={props.mensaje} tipo={7}/>
                                </Box> ;
        default:
            component = <Box marginRight={1}  marginLeft={1} className={classes['box-empleado']} >
                                  <ContenidoMensajeMovil {...styles}/>
                            </Box>;
    }

    return component;
}

export const MensajeComponenteCliente = (props:MensajeMovilProp) :JSX.Element =>{
    const classes = props.classes;
    const mensaje = props.mensaje;

    let ultimaFecha:string = '';
    if (mensaje.Timestamp) {
        const ultimoMensaje = fechaOrganizada(mensaje.Timestamp as string);
         ultimaFecha = `${ultimoMensaje.diaNombre} ${ultimoMensaje.hora}`;
    }
    let styles:IContenidoMensaje;
    let component:JSX.Element;
    styles = {
        bgColor:'#3287EA',
        borderRadius:'5px 5px 0px 5px',
        fontColor:'#FFFFFF',
        fecha:ultimaFecha,
        mensaje: mensaje.Mensaje,
        nombre: mensaje.Nombre ? nombreMensaje(mensaje.Nombre,mensaje.Remitente) : '',
        mobile: mensaje.Mobile ? mensaje.Mobile : false,
        type: mensaje.Type
    }

    switch (mensaje.Type) {
        case 'ALERTA_SOPORTE':
            return component = <Box marginRight={1}  marginLeft={1}>
                                   <Alerta guia={props.guia} tipo={3} mensaje_={props.mensaje} mensaje={mensaje.Mensaje}/>
                               </Box>;
        case 'FINALIZADO':
            return component = <Box marginRight={1}  marginLeft={1} >
                                   <Alerta mensaje_={props.mensaje}  tipo={2}/>
                                </Box>;
        default:
                    component= <Box marginRight={1}  marginLeft={1} className={classes['box']}>
                                     <ContenidoMensajeMovil {...styles}/>      
                               </Box>;
    }

    return component;

}

export const MensajeMovil = withStyles(mensajeMovilStyles)(MensajeMovilComponent);